module.exports = __webpack_public_path__ + "static/media/background_premium_gold.9f07f45f.jpg";